











































































































































import { PropType } from 'vue';
import {
  EJackpotCampaignStatusType,
  IJackpotCampaignFiltersParams,
  ValidationRules
} from '@/api/schema';
import pickBy from 'lodash/pickBy';
import * as vr from '@/helpers/validation';

const VStatus = (): Promise<any> => import('@/components/VStatus.vue');
const BaseDialog = (): Promise<any> => import('@/components/BaseDialog.vue');
const VExtendedDataPicker = (): Promise<any> =>
  import('@/components/VExtendedDataPicker.vue');

const defaultFilters = {
  createdAfter: null,
  createdBefore: null,
  startAfter: null,
  finishBefore: null,
  status: []
};

export default {
  name: 'CopyStakeJackpotCampaignsTableFiltersDialog',
  components: {
    BaseDialog,
    VExtendedDataPicker,
    VStatus
  },
  props: {
    value: {
      type: Boolean,
      default: (): boolean => false
    },
    filters: {
      type: Object as PropType<IJackpotCampaignFiltersParams> | null,
      default: { ...defaultFilters }
    }
  },
  data(): any {
    return {
      isFormValid: false,
      formData: { ...defaultFilters },

      statusCheckboxesConfig: [
        {
          label: 'Finished',
          type: 'additional-finished',
          value: EJackpotCampaignStatusType.FINISHED
        },
        {
          label: 'Running',
          type: 'system-success',
          value: EJackpotCampaignStatusType.ACTIVE
        },
        {
          label: 'Pending',
          type: 'additional-pending',
          value: EJackpotCampaignStatusType.PENDING
        }
        // Temporarily hidden
        // {
        //   label: 'Deleted',
        //   type: 'additional-deleted',
        //   value: EJackpotCampaignStatusType.DELETED
        // }
      ]
    };
  },
  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean): void {
        this.$emit('input', value);
      }
    },
    isDisabledSubmitBtn(): boolean {
      return !this.isFormValid;
    },
    rules(): ValidationRules {
      return {
        createdBefore: [
          (v) => vr.isDateAfterOrEqual(v, this.formData.createdAfter)
        ],
        finishBefore: [
          (v) => vr.isDateAfterOrEqual(v, this.formData.startAfter)
        ]
      };
    }
  },
  watch: {
    'formData.createdAfter'(): void {
      this.$nextTick(() => {
        if (this.formData.createdBefore) this.$refs.createdBefore?.validate();
      });
    },
    'formData.startAfter'(): void {
      this.$nextTick(() => {
        if (this.formData.finishBefore) this.$refs.finishBefore?.validate();
      });
    }
  },
  methods: {
    handlerClickSubmitButton(): void {
      let newFilters = pickBy(
        this.formData,
        (value) =>
          value !== null &&
          value !== '' &&
          (!Array.isArray(value) || value.length > 0)
      );

      newFilters = Object.keys(newFilters).length > 0 ? newFilters : null;

      this.$emit('submit');
      this.$emit('update:filters', newFilters);

      this.closeDialog();
    },
    handlerClickCleanBtn(): void {
      this.resetForm();
    },
    handlerClickCloseBtn(): void {
      this.closeDialog();
    },
    resetForm(): void {
      this.formData = {
        ...defaultFilters
      };
    },
    async closeDialog(): Promise<void> {
      this.$emit('close');
      this.showDialog = false;

      this.$nextTick(() => {
        this.formData = this.filters
          ? {
              status: [],
              ...this.filters
            }
          : { ...defaultFilters };
      });
    }
  }
};
